export default __webpack_public_path__ + "bg_anli_shouji0142301f.png";